import { render, staticRenderFns } from "./Discount.vue?vue&type=template&id=8d8861ac&scoped=true"
import script from "./Discount.vue?vue&type=script&lang=ts"
export * from "./Discount.vue?vue&type=script&lang=ts"
import style0 from "./Discount.vue?vue&type=style&index=0&id=8d8861ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8861ac",
  null
  
)

export default component.exports